import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentService } from '@app/core/environment.service';

@Component({
  selector: 'app-logo',
  standalone: true,
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  environmentService = inject(EnvironmentService);
}
